export { default } from './button'
export { OutlineIcon } from './outline'
// import { useEffect, useRef, useState } from "react";

// import { getWindowSize } from "@helper/util/useWindowSize";

// import styled from "styled-components";
// const Container = styled.button`
//   background: linear-gradient(270deg, #fb8b26 0%, #eeaf12 100%);
//   border: none;
//   border-radius: 40px;
//   color: white;
//   cursor: pointer;
//   font-size: 16px;
//   /* padding: 16px 30px; */
//   padding: 5px 12px;
//   text-align: center;
//   &:hover {
//     background: white;
//     color: var(--bg-primary);
//   }
// `;
// const RoundContainer = styled.button`
//   align-items: center;
//   background-color: var(--bg-primary);
//   border: none;
//   border-radius: 50%;
//   cursor: pointer;
//   display: flex;
//   font-size: 16px;
//   height: 50px;
//   justify-content: center;
//   text-align: center;
//   width: 50px;
//   &:hover {
//     background-color: var(--clr-primary);
//   }
//   &.transparent {
//     background-color: transparent;
//     &:hover {
//       background-color: var(--bg-tertiary);
//     }
//   }
//   img {
//     height: 25px;
//     width: 25px;
//   }
// `;
// export const RoundOutlineContainer = styled.div`
//   align-items: center;
//   border-radius: 5px;
//   cursor: pointer;
//   display: flex;
// `;

// interface Props {
//   color: string;
//   colorHover: string;
//   mColor: string;
//   mColorHover: string;
//   icon: string;
//   iconHover: string;
//   mIcon: string;
//   mIconHover: string;
//   label: string;
//   onClick: React.MouseEventHandler<HTMLButtonElement>;
//   size: string;
//   transparent: boolean;
// }

// export const IconButton = ({ icon, onClick, transparent }: Props) => {
//   const defaultClick = () => alert("Button is Clicked!");
//   return (
//     <RoundContainer
//       className={transparent ? "transparent " : ""}
//       onClick={onClick || defaultClick}
//     >
//       <img src={icon || ""} />
//     </RoundContainer>
//   );
// };

// export const SolidButton = styled.button`
//   background-color: var(--bg-primary);
//   border: 2px solid var(--bg-secondary);
//   border-radius: 10px;
//   color: var(--bg-secondary);
//   cursor: pointer;
//   height: 40px;
//   /* margin-bottom: 1em; */
//   /* padding: .75em 1.5em; */
//   /* font-size: 11pt; */
//   font-weight: 500;
//   &:hover {
//     background-color: var(--bg-secondary);
//     border: 2px solid var(--bg-primary);
//     color: var(--bg-primary);
//   }
//   &.authentication {
//     width: 320px;
//   }
//   &.padded {
//     padding: 0.75em 1.5em;
//   }
// `;

// export const LabelButton = styled.button`
//   background-color: transparent;
//   border: none;
//   border-radius: 10px;
//   color: var(--bg-primary);
//   cursor: pointer;
//   height: 40px;
//   /* margin: .75em .5em; */

//   font-style: normal;
//   font-weight: 600;
//   font-size: 12px;
//   line-height: 18px;

//   &:hover {
//     color: var(--clr-primary);
//   }
// `;

// export const OutlineIcon = ({
//   color,
//   colorHover,
//   icon,
//   iconHover,
//   mColor,
//   mIcon,
//   label,
//   onClick,
//   size = "35px",
// }: Props) => {
//   const windowSize = getWindowSize();
//   const [hovered, setHovered] = useState(false);
//   const ref = useRef(null);
//   useEffect(() => {
//     const mouseOver = () => setHovered(true);
//     const mouseOut = () => setHovered(false);
//     ref.current && ref.current.addEventListener("mouseover", mouseOver);
//     ref.current && ref.current.addEventListener("mouseout", mouseOut);
//     return () => {
//       ref.current && ref.current.removeEventListener("mouseover", mouseOver);
//       ref.current && ref.current.removeEventListener("mouseout", mouseOut);
//     };
//   }, []);
//   return (
//     <RoundOutlineContainer
//       style={{
//         background: !hovered
//           ? windowSize.width >= 640
//             ? color
//             : mColor || color
//           : colorHover || "#EEEEEE",
//         border: `2px solid ${
//           hovered
//             ? windowSize.width >= 640
//               ? color
//               : mColor || color
//             : colorHover || "#EEEEEE"
//         }`,
//         color: `2px solid ${
//           hovered
//             ? windowSize.width >= 640
//               ? color
//               : mColor || color
//             : colorHover || "#EEEEEE"
//         }`,
//         height: size,
//         justifyContent: icon ? "space-evenly" : "center",
//         // width: size
//       }}
//       onClick={onClick}
//       ref={ref}
//     >
//       {!hovered && (
//         <img alt="" src={windowSize.width >= 640 ? icon : mIcon || icon} />
//       )}
//       {hovered && iconHover && <img alt="" src={iconHover} />}
//       {label}
//     </RoundOutlineContainer>
//   );
// };

// const Button = ({ children, label, onClick }: Props) => {
//   const defaultClick = () => alert("Button is Clicked!");
//   return (
//     <Container onClick={onClick || defaultClick}>{label || children}</Container>
//   );
// };
// export default Button;
